import { render, staticRenderFns } from "./SortableArrows.vue?vue&type=template&id=78fb188d&scoped=true&"
import script from "./SortableArrows.vue?vue&type=script&lang=ts&"
export * from "./SortableArrows.vue?vue&type=script&lang=ts&"
import style0 from "./SortableArrows.vue?vue&type=style&index=0&id=78fb188d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb188d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
